import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Collapse,
} from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import HomeIcon from "@mui/icons-material/Home";
import MarketingIcon from "@mui/icons-material/TrendingUp";
import FunnelIcon from "@mui/icons-material/FilterList";
import ScheduleIcon from "@mui/icons-material/Schedule";
import MailIcon from "@mui/icons-material/Mail";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PeopleIcon from "@mui/icons-material/People";
import WorkspacesIcon from "@mui/icons-material/Workspaces";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import BusinessIcon from "@mui/icons-material/Business";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AddTaskIcon from "@mui/icons-material/AddTask";
// Import new icons
import AssignmentIcon from "@mui/icons-material/Assignment";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import EqualizerIcon from "@mui/icons-material/Equalizer";
// Add this to your imports
import EventBusyIcon from "@mui/icons-material/EventBusy";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ListAltIcon from "@mui/icons-material/ListAlt";
import StorageIcon from "@mui/icons-material/Storage";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import BadgeIcon from "@mui/icons-material/Badge";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import PublicIcon from "@mui/icons-material/Public";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import WorkIcon from "@mui/icons-material/Work";

const MenuList = ({ roleId, gradeCode, isDarkTheme, handleMenuItemClick }) => {
  // Check if user is authenticated
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  
  // State for Master Data submenu
  const [masterDataOpen, setMasterDataOpen] = useState(false);
  
  const handleMasterDataClick = () => {
    setMasterDataOpen(!masterDataOpen);
  };
  
  // If not authenticated, return empty List
  if (!isAuthenticated) {
    return <List></List>;
  }

  return (
    <List>
      {/* Common Menu for All Roles */}
      {/* Task Dashboard renamed to Task Overview with better icon */}
      <ListItem
        button
        onClick={() => handleMenuItemClick("/task-dashboard")}
        sx={{
          borderRadius: "8px",
          margin: "4px 16px",
          "&:hover": {
            backgroundColor: isDarkTheme
              ? "rgba(255,255,255,0.1)"
              : "rgba(0,0,0,0.04)",
            transform: "translateX(4px)",
          },
          transition: "all 0.3s ease",
        }}
      >
        <ListItemIcon>
          <EqualizerIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
        </ListItemIcon>
        <ListItemText primary="Task Overview" />
      </ListItem>

      {/* My Tasks renamed to My Daily Tasks with better icon */}
      <ListItem
        button
        onClick={() => handleMenuItemClick("/my-tasks")}
        sx={{
          borderRadius: "8px",
          margin: "4px 16px",
          "&:hover": {
            backgroundColor: isDarkTheme
              ? "rgba(255,255,255,0.1)"
              : "rgba(0,0,0,0.04)",
            transform: "translateX(4px)",
          },
          transition: "all 0.3s ease",
        }}
      >
        <ListItemIcon>
          <FormatListBulletedIcon
            sx={{ color: isDarkTheme ? "#fff" : "#000" }}
          />
        </ListItemIcon>
        <ListItemText primary="My Daily Tasks" />
      </ListItem>

      {/* My Tasks renamed to My Leave  with better icon */}
      {/* Leave menu with more appropriate icon */}
      <ListItem
        button
        onClick={() => handleMenuItemClick("/my-leave")}
        sx={{
          borderRadius: "8px",
          margin: "4px 16px",
          "&:hover": {
            backgroundColor: isDarkTheme
              ? "rgba(255,255,255,0.1)"
              : "rgba(0,0,0,0.04)",
            transform: "translateX(4px)",
          },
          transition: "all 0.3s ease",
        }}
      >
        <ListItemIcon>
          <EventBusyIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
        </ListItemIcon>
        <ListItemText primary="Leave" />
      </ListItem>

      {/* Add Task Menu for Specific Grades (G3 to G10) */}
      {(gradeCode === "G3" ||
        gradeCode === "G4" ||
        gradeCode === "G5" ||
        gradeCode === "G6" ||
        gradeCode === "G7" ||
        gradeCode === "G8" ||
        gradeCode === "G9" ||
        gradeCode === "G10") && (
        <ListItem
          button
          onClick={() => handleMenuItemClick("/add-task")}
          sx={{
            borderRadius: "8px",
            margin: "4px 16px",
            "&:hover": {
              backgroundColor: isDarkTheme
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.04)",
              transform: "translateX(4px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ListItemIcon>
            <AddTaskIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
          </ListItemIcon>
          <ListItemText primary="Create New Task" />
        </ListItem>
      )}

      {/* Role-Specific Menus */}
      {roleId === "Creator" && (
        <ListItem
          button
          onClick={() => handleMenuItemClick("/home")}
          sx={{
            borderRadius: "8px",
            margin: "4px 16px",
            "&:hover": {
              backgroundColor: isDarkTheme
                ? "rgba(255,255,255,0.1)"
                : "rgba(0,0,0,0.04)",
              transform: "translateX(4px)",
            },
            transition: "all 0.3s ease",
          }}
        >
          <ListItemIcon>
            <CodeIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
          </ListItemIcon>
          <ListItemText primary="Add Post Code" />
        </ListItem>
      )}

      {/* Show All Menus for CPO */}
      {roleId === "OL-PT-ROLE-001" && (
        <>
          <ListItem
            button
            onClick={() => handleMenuItemClick("/cpo-dashboard")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <HomeIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem
            button
            onClick={() => handleMenuItemClick("/digi-marketing")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <MarketingIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Digi Marketing" />
          </ListItem>
          <ListItem
            button
            onClick={() => handleMenuItemClick("/sales-funnel")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <FunnelIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Sales Funnel" />
          </ListItem>
        </>
      )}

     
      

      {/* Show Navigation for Chairman */}
      {roleId === "U-GROUP-001" && (
        <>
          <ListItem
            button
            onClick={() => handleMenuItemClick("/add-task")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <AddTaskIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Create New Task" />
          </ListItem>

          <ListItem
            button
            onClick={() => handleMenuItemClick("/create-people")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <PersonAddIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Create People" />
          </ListItem>

          <ListItem
            button
            onClick={() => handleMenuItemClick("/people")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <PeopleIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="People" />
          </ListItem>

          {/* Home Navigation */}
          <ListItem
            button
            onClick={() => handleMenuItemClick("/umbrella-view")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <DashboardIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Umbrella View" />
          </ListItem>

          <ListItem
            button
            onClick={() => handleMenuItemClick("/company-overview")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <BusinessIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Company Overview" />
          </ListItem>

                    <ListItem
            button
            onClick={() => handleMenuItemClick("/all-tasks")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <ListAltIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="All Tasks" />
          </ListItem>

          {/* Master Data Menu with Submenu */}
          <ListItem
            button
            onClick={handleMasterDataClick}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <StorageIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Master Data" />
            {masterDataOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={masterDataOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem
                button
                onClick={() => handleMenuItemClick("/master-data/roles")}
                sx={{
                  pl: 4,
                  borderRadius: "8px",
                  margin: "2px 16px",
                  "&:hover": {
                    backgroundColor: isDarkTheme
                      ? "rgba(255,255,255,0.08)"
                      : "rgba(0,0,0,0.03)",
                    transform: "translateX(4px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <ListItemIcon>
                  <BadgeIcon sx={{ color: isDarkTheme ? "#fff" : "#000", fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText primary="Roles" />
              </ListItem>

              <ListItem
                button
                onClick={() => handleMenuItemClick("/master-data/departments")}
                sx={{
                  pl: 4,
                  borderRadius: "8px",
                  margin: "2px 16px",
                  "&:hover": {
                    backgroundColor: isDarkTheme
                      ? "rgba(255,255,255,0.08)"
                      : "rgba(0,0,0,0.03)",
                    transform: "translateX(4px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <ListItemIcon>
                  <CorporateFareIcon sx={{ color: isDarkTheme ? "#fff" : "#000", fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText primary="Departments" />
              </ListItem>

              <ListItem
                button
                onClick={() => handleMenuItemClick("/master-data/grades")}
                sx={{
                  pl: 4,
                  borderRadius: "8px",
                  margin: "2px 16px",
                  "&:hover": {
                    backgroundColor: isDarkTheme
                      ? "rgba(255,255,255,0.08)"
                      : "rgba(0,0,0,0.03)",
                    transform: "translateX(4px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <ListItemIcon>
                  <MilitaryTechIcon sx={{ color: isDarkTheme ? "#fff" : "#000", fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText primary="Grades" />
              </ListItem>

              <ListItem
                button
                onClick={() => handleMenuItemClick("/master-data/leave-types")}
                sx={{
                  pl: 4,
                  borderRadius: "8px",
                  margin: "2px 16px",
                  "&:hover": {
                    backgroundColor: isDarkTheme
                      ? "rgba(255,255,255,0.08)"
                      : "rgba(0,0,0,0.03)",
                    transform: "translateX(4px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <ListItemIcon>
                  <BeachAccessIcon sx={{ color: isDarkTheme ? "#fff" : "#000", fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText primary="Leave Types" />
              </ListItem>

              <ListItem
                button
                onClick={() => handleMenuItemClick("/master-data/countries")}
                sx={{
                  pl: 4,
                  borderRadius: "8px",
                  margin: "2px 16px",
                  "&:hover": {
                    backgroundColor: isDarkTheme
                      ? "rgba(255,255,255,0.08)"
                      : "rgba(0,0,0,0.03)",
                    transform: "translateX(4px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <ListItemIcon>
                  <PublicIcon sx={{ color: isDarkTheme ? "#fff" : "#000", fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText primary="Countries" />
              </ListItem>

              <ListItem
                button
                onClick={() => handleMenuItemClick("/master-data/levels")}
                sx={{
                  pl: 4,
                  borderRadius: "8px",
                  margin: "2px 16px",
                  "&:hover": {
                    backgroundColor: isDarkTheme
                      ? "rgba(255,255,255,0.08)"
                      : "rgba(0,0,0,0.03)",
                    transform: "translateX(4px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <ListItemIcon>
                  <LocationOnIcon sx={{ color: isDarkTheme ? "#fff" : "#000", fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText primary="Levels" />
              </ListItem>

              <ListItem
                button
                onClick={() => handleMenuItemClick("/master-data/designations")}
                sx={{
                  pl: 4,
                  borderRadius: "8px",
                  margin: "2px 16px",
                  "&:hover": {
                    backgroundColor: isDarkTheme
                      ? "rgba(255,255,255,0.08)"
                      : "rgba(0,0,0,0.03)",
                    transform: "translateX(4px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                <ListItemIcon>
                  <WorkIcon sx={{ color: isDarkTheme ? "#fff" : "#000", fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText primary="Designations" />
              </ListItem>
            </List>
          </Collapse>

        </>
      )}

      {/* Show Navigation for HR Role with specific grades */}
      {(roleId === "U-HR-ROLE-001" && 
       (gradeCode === "G6" || 
        gradeCode === "G7" || 
        gradeCode === "G8" || 
        gradeCode === "G9" || 
        gradeCode === "G10")) && (
        <>
          <ListItem
            button
            onClick={() => handleMenuItemClick("/people")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <PeopleIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="People" />
          </ListItem>

          <ListItem
            button
            onClick={() => handleMenuItemClick("/create-people")}
            sx={{
              borderRadius: "8px",
              margin: "4px 16px",
              "&:hover": {
                backgroundColor: isDarkTheme
                  ? "rgba(255,255,255,0.1)"
                  : "rgba(0,0,0,0.04)",
                transform: "translateX(4px)",
              },
              transition: "all 0.3s ease",
            }}
          >
            <ListItemIcon>
              <PersonAddIcon sx={{ color: isDarkTheme ? "#fff" : "#000" }} />
            </ListItemIcon>
            <ListItemText primary="Create People" />
          </ListItem>
        </>
      )}

    </List>
  );
};

export default MenuList;
